<template>
  <div class="personal-settings">
    <div class="header">
      <div class="title">
        <ul>
          <li id="title-icon">
            <div></div>
            <span>個人設定</span>
          </li>
        </ul>
      </div>
      <!-- <h1 class="title">個人設定</h1> -->
    </div>
    <validation-observer ref="obs" v-slot="ObserverProps">
      <div class="section">
        <div class="container">
          <div class="sub-title">ユーザー名</div>
          <div
            class="error-message mdi mdi-alert-circle-outline"
            v-if="profile.error"
          >
            {{ profile.error }}
          </div>
          <dl class="columns">
            <dt>ユーザー名</dt>
            <ValidationProvider
              rules="required|max:50"
              immediate
              v-slot="ProviderProps"
            >
              <input
                type="text"
                v-model="profile.displayName"
                autocomplete="off"
              />
              <div class="validation-error">
                {{ ProviderProps.errors[0] }}
              </div>
            </ValidationProvider>
          </dl>
        </div>
      </div>
      <div id="button-area">
        <div class="left-box" />
        <div class="center-box">
          <span
            class="btn wide btn-submit"
            :class="{
              active: true,
              disable: ObserverProps.invalid,
            }"
            @click="updateUser"
            >ユーザー名を変更</span
          >
        </div>
      </div>
    </validation-observer>
    <validation-observer ref="obs" v-slot="ObserverProps">
      <div class="section">
        <div class="container">
          <div class="sub-title">パスワード</div>
          <div
            class="error-message mdi mdi-alert-circle-outline"
            v-if="password.error"
          >
            {{ password.error }}
          </div>
          <dl class="columns">
            <dt>現在のパスワード</dt>
            <dd>
              <ValidationProvider
                rules="required"
                immediate
                v-slot="ProviderProps"
              >
                <input type="password" v-model="password.currentPassword" />
                <div class="validation-error">
                  {{ ProviderProps.errors[0] }}
                </div>
              </ValidationProvider>
            </dd>
          </dl>
          <dl class="columns">
            <dt>新パスワード</dt>
            <dd>
              <ValidationProvider
                rules="required|complexPassword"
                immediate
                v-slot="ProviderProps"
              >
                <input type="password" v-model="password.newPassword" />
                <p
                  class="legend"
                  :class="{ 'validation-error': ProviderProps.invalid }"
                >
                  8文字以上、アルファベット大文字・小文字・数字をそれぞれ1つ以上含む。
                </p>
              </ValidationProvider>
            </dd>
          </dl>
        </div>
      </div>
      <div id="button-area">
        <div class="left-box" />
        <div class="center-box">
          <span
            class="btn wide btn-submit"
            :class="{
              active: true,
              disable: ObserverProps.invalid,
            }"
            @click="changePassword"
            >パスワードを変更</span
          >
        </div>
      </div>
    </validation-observer>
    <div class="section">
      <div class="container">
        <div class="sub-title">退会</div>
        <div style="margin: 10px; text-align: center">
          <span style="color: #e23333; font-size: 0.8rem"
            >アカウントを作成したユーザーで退会できます。</span
          >
        </div>
      </div>
    </div>
    <div id="button-area" style="margin: 0 0 100px 0">
      <div class="left-box" />
      <div class="center-box">
        <span
          class="btn wide btn-submit"
          :class="{
            active: isRootUser,
            disable: !isRootUser,
          }"
          @click="deleteAccount"
          >退会する</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Auth, API } from "aws-amplify";
import { mapActions } from "vuex";
import Loader from "@/mixins/loader";
import Dialog from "@/mixins/dialog";

export default {
  mixins: [Loader, Dialog],

  data() {
    return {
      logger: null,
      profile: {
        displayName: null,
        error: null,
      },
      password: {
        currentPassword: null,
        newPassword: null,
        error: null,
      },
      isRootUser: false,
    };
  },

  async mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
    try {
      let prof = await this.showProfile();
      this.profile.displayName = prof.displayName;

      const aid = await this.showAccountID();
      const uid = await this.showUserId();
      const accountInfo = await this.showAccount(aid);
      if (accountInfo.root_users && accountInfo.root_users.length > 0) {
        this.isRootUser = accountInfo.root_users[0] === uid;
      }
    } catch (err) {
      this.logger.error(err);
    }

    this.$emit("hideMap");
  },

  methods: {
    ...mapActions([
      "showProfile",
      "showAccountID",
      "showUserId",
      "showAccount",
    ]),

    async updateUser() {
      this.loading(async () => {
        let apiName = "AdminQueries";
        let path = "/adminUpdateUser";
        let myInit = {
          body: {
            displayName: this.profile.displayName,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `${(await Auth.currentSession())
              .getAccessToken()
              .getJwtToken()}`,
          },
        };
        try {
          // パラメータ補完
          let prof = await this.showProfile();
          myInit.body.username = prof.username;
          myInit.body.email = prof.email;

          // 実行
          await API.post(apiName, path, myInit);

          // メッセージクリア
          this.profile.error = null;
          // 成功通知
          this.$toasted.success("プロフィールを変更しました。", {
            position: "top-center",
            duration: 3000,
          });
        } catch (err) {
          if (err.response && err.response.data && err.response.data.message) {
            this.profile.error = err.response.data.message;
          } else if (err.message) {
            this.profile.error = err.message;
          } else {
            this.profile.error = this.$Amplify.I18n.get(err.message || err);
          }

          this.logger.error(this.profile.error);
          this.logger.error(err);
        }

        // サイドバーの表示更新のためプロフィールを取得（storeのstateを更新）
        try {
          await this.showProfile();
        } catch (err) {
          this.logger.error(err);
        }
      });
    },

    async changePassword() {
      this.loading(async () => {
        try {
          // パスワード変更
          const user = await Auth.currentAuthenticatedUser();
          await Auth.changePassword(
            user,
            this.password.currentPassword,
            this.password.newPassword
          );

          // 入力クリア
          this.password.currentPassword = null;
          this.password.newPassword = null;
          // メッセージクリア
          this.password.error = null;
          // 成功通知
          this.$toasted.success("パスワードを変更しました。", {
            position: "top-center",
            duration: 3000,
          });
        } catch (err) {
          if (err.code === "NotAuthorizedException") {
            this.password.error = "現在のパスワードが正しくありません。";
          } else if (err.code === "LimitExceededException") {
            this.password.error =
              "試行回数の上限に達しました。時間をおいてから再度お試しください。";
          } else {
            this.password.error = this.$Amplify.I18n.get(err.message || err);
          }
          this.logger.error(this.password.error);
          this.logger.error(err);
        }
      });
    },
    deleteAccount() {
      this.$router.push({
        name: "delete-account",
      });
    },
  },
};
</script>

<style lang="scss">
.personal-settings {
  // .header {
  //   margin: 2rem;
  // }
  .section {
    overflow: auto;
    width: 50%;
    height: calc(100% - 130px);
    position: relative;
    margin-left: auto;
    margin-right: auto;

    .container {
      margin: 2rem;
      margin-left: auto;
      margin-right: auto;

      .sub-title {
        font-size: 18px;
        margin: 10px 0;
      }

      dl.columns {
        width: 100%;
        display: grid;
        grid-template-columns: 170px 1fr;
        align-items: top;
        grid-gap: 0px 0px;
        margin: 0;
        padding: 0;
        font-size: 16px;
        color: #333;
      }

      .columns dt {
        display: block;
        text-align: left;
        width: 100%;
        margin: 0;
        padding: 16px;
      }

      .columns dd {
        display: block;
        width: 100%;
        border-left: solid 1px #ddd;
        margin: 0;
        padding: 16px;

        &.input-with-unit {
          display: flex;
          align-items: center;
          .unit {
            margin-left: 1rem;
            word-break: keep-all;
          }
        }
      }
      .columns dt:nth-of-type(odd) {
        background: #f3f3f3;
      }
      .columns dd:nth-of-type(odd) {
        background: #f3f3f3;
      }

      /* フォーム */

      input[type="text"],
      input[type="password"],
      input[type="date"] {
        width: 100%;
        height: 40px;
        border-radius: 20px;
        border: solid 1px var(--purple);
        padding: 0 16px;
        font-size: 16px;
        outline: none;
      }

      input[type="text"]:focus,
      input[type="password"]:focus,
      input[type="date"]:focus {
        background: var(--purple-tertiary);
      }

      select {
        height: 40px;
        border-radius: 20px;
        border: solid 1px var(--purple);
        padding: 0 38px 0 16px;
        font-size: 16px;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
          calc(100% - 10px) center;
        background-size: 25px 25px;
      }

      select:focus {
        background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
          calc(100% - 10px) center var(--purple-tertiary);
        background-size: 25px 25px;
      }

      textarea {
        font-size: 16px;
        width: 100%;
        min-height: 200px;
        white-space: pre-wrap;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        border: solid 1px var(--purple);
        padding: 10px;
        border-radius: 10px 10px 0 10px;
      }

      textarea:focus {
        background: var(--purple-tertiary);
      }

      input[type="radio"] {
        display: none;
      }
      input[type="radio"] + label {
        padding: 0 20px 0 0;
      }
      input[type="radio"]:disabled + label {
        color: #aaa;
      }

      input[type="radio"] + label:before {
        display: inline-block;
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_off.svg") no-repeat center
          left;
        background-size: 24px 24px;
        padding: 0 16px 0 0;
      }
      input[type="radio"]:checked + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_on.svg") no-repeat center left;
        background-size: 24px 24px;
        display: inline-block;
      }
      input[type="radio"]:disabled + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_disabled.svg") no-repeat
          center left;
        background-size: 24px 24px;
        display: inline-block;
      }

      input[type="checkbox"] {
        display: none;
      }
      input[type="checkbox"] + label {
        padding: 0 20px 0 0;
      }

      input[type="checkbox"] + label:before {
        display: inline-block;
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_off.svg") no-repeat center
          left;
        background-size: 24px 24px;
        padding: 0 16px 0 0;
      }
      input[type="checkbox"]:checked + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_on.svg") no-repeat center
          left;
        background-size: 24px 24px;
        display: inline-block;
      }
    }
  }

  #button-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;

    .right-box {
      right: 0;
      bottom: 0;
      width: 25%;
    }
    .center-box {
      display: inline;
      text-align: center;
      width: calc(100% - 50%);
    }
    .left-box {
      left: 0;
      bottom: 0;
      width: 25%;
      .mobile & {
        width: unset;
      }
    }
    .btn {
      display: inline-block;
      background: white;
      font-size: 14px;
      text-align: center;
      width: 130px;
      height: 30px;
      border-radius: 15px;
      color: var(--purple);
      padding: 6px 20px;
      margin: 10px auto 10px;
      cursor: pointer;
      &.wide {
        width: 160px;
      }
      &.disable {
        opacity: 0.5;
        cursor: inherit;
        pointer-events: none;
      }
      &.btn-submit {
        background: var(--purple);
        color: #fff;
        margin-left: 10px;
        margin-right: 10px;
      }
      &.btn-cancel {
        background: var(--purple-tertiary);
        color: #000;
        margin-left: 10px;
        margin-right: 10px;
      }
    }
    .text {
      right: 0;
      bottom: 0;
      display: block;
      font-size: 14px;
      padding: 3px 0px;
      margin: 10px 0;
      text-align: center;
      color: var(--purple);
      border-bottom: solid 4px transparent;
      opacity: 0.5;
      pointer-events: none;
      width: 130px;
    }
    .text.active {
      border-bottom: solid 4px var(--purple-secondary);
      opacity: 1;
      cursor: pointer;
      pointer-events: inherit;
    }
    .text::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_delete.svg") no-repeat center left;
      background-size: 20px 20px;
      padding: 0 0 0 5px;
    }
  }
  /* タイトル */
  .header .title {
    width: 100%;
    // margin: 20px 0 0 0;
    box-sizing: border-box;
    // border-bottom: solid 2px var(--purple-secondary);
  }
  .header .title ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
    box-sizing: border-box;
    user-select: none;
  }
  .header .title li {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 60px; /* 各メニューの高さ */
    // cursor: pointer;
    background: none;
    z-index: 10;
    display: flex;
    align-items: center;
    // border-bottom: 1px solid;
    // border-image: linear-gradient(
    //   to right,
    //   #fff 0%,
    //   #fff 10%,
    //   #eee 10%,
    //   #eee 100%
    // );
    // border-image-slice: 1;
    // color: var(--purple-secondary);

    // background-color: var(--purple-tertiary);
    color: var(--purple);
  }
  .header .title li span {
    font-size: 1.1rem;
    // padding: 0px 0px 0px 10px;
    transition: padding 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    color: var(--purple);
  }
  .header .title li > div {
    width: 50px;
    height: 100%;
  }
  /* アイコンの指定 */
  #title-icon > div {
    background: url("~@/assets/icons/ic_setting_personal.svg") no-repeat center
      center;
  }
}
</style>
